import { cards, type fullAgents } from '../../utils/cards'
import { Step } from '../../utils/steps'
import { BottomText } from '../title-and-text/bottom-text'

import { Card } from './card'

import style from './plus.module.scss'

const Plus = ({ agents }: { agents: typeof fullAgents }) => {
  return (
    <div className={style.container} data-step={Step.Plus}>
      {cards.map(card => (
        <Card key={card.title} {...card} added={agents.some(agent => agent.name === card.title)} />
      ))}
      <BottomText>Customize your team of agents from a growing roster.</BottomText>
    </div>
  )
}

export default Plus
